import React from 'react'
import project from '../../project'
import { Tracking } from '../../../NodeModules/nnd-track-page'
import HTMLFlipBook from 'react-pageflip';
import "../assets/styles/home.scss"

const apiURL_storage = 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com/interactives/MessageBoardKingsVisit2024/prod/MessageBoardKingsVisit2024.json'

let nndWMBtimer = ''

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      view: 'messages',
      firstInteraction: false,
      submitDisabled: false,
      submitSuccess: false,
      // manualMode: false,
      pauseMode: false,
      messageData: [],
      currentMessage: null,
      currentIndex: null,
      valueName: '',
      valueLocation: '',
      valueMessage: '',
      mode: null,
      isDesktop: null,
      bookMessages: undefined,
      countName: 0,
      countLocation: 0,
      countMessage: 0,
    }
    
    this.handleChangeName = this.handleChangeName.bind(this);
    this.inputCount = this.inputCount.bind(this);
    this.handleChangeLocation = this.handleChangeLocation.bind(this);
    this.handleChangeMessage = this.handleChangeMessage.bind(this);
    this.nextBookButtonClick = this.nextBookButtonClick.bind(this);
    this.prevBookButtonClick = this.prevBookButtonClick.bind(this);
    const thisState = this

    // this.addBodyEvents()

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('mouseenter', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })

    const deviceAttribute = document.body.getAttribute('data-device')
    // console.log('isDeskMobAttribute', isDeskMobAttribute)
    const isDesktop = ( deviceAttribute === 'desktop' ) ? true : false
    thisState.state.isDesktop = isDesktop

    // console.log('isDesktop: ', isDesktop)

    const whichMode = appContainer.getAttribute('data-mode')
    // console.log('whichMode', whichMode)
    thisState.state.mode = whichMode
    
  }

  componentDidMount () {
    this.loadData ()
  }

  onSubmit (e) {
    this.setState({
      submitDisabled: true
    })

    if (this.state.valueName === '' || this.state.valueLocation === '' || this.state.valueMessage === '') {
      this.setState({
        submitDisabled: false
      })
      return
    }

    const data = {
      Message: this.state.valueMessage.replace(/\r?\n|\r/g, ' '),
      Name: this.state.valueName,
      Location: this.state.valueLocation,
      Created: Date.now(),
      Approved: 'no',
      Tribute: 'KingsVisit',
      Origin: window.location.href
    };

    fetch('https://api.sheetmonkey.io/form/xAzeChvCzT7hBWya8oG7WP', {
      
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((result) => {
      // Handle the result
      // console.log('result', result)
      this.setState({
        submitSuccess: true,
        submitDisabled: false
      })
      
    });

  }

  handleChangeName (event) {    
    this.setState({valueName: event.target.value})
  }
  handleChangeLocation (event) {    
    this.setState({valueLocation: event.target.value})
  }
  handleChangeMessage (event) {    
    this.setState({valueMessage: event.target.value})
  }

  inputCount (event) {

    if (event.target.name == 'nam') {
      this.setState({
        countName: event.target.value.length
      })
    } else if (event.target.name == 'loc') {
      this.setState({
        countLocation: event.target.value.length
      })
    } else if (event.target.name == 'mes') {
      this.setState({
        countMessage: event.target.value.length
      })
    }
  }

  nextMessage (direction, mode) {
    if (mode === 'manual') {
      
      //clear timeout
      clearTimeout(nndWMBtimer)

      this.setState({
        pauseMode: true
      })

      // exit pause mode after 30 seconds, revert to auto 
      nndWMBtimer = setTimeout(() => {
        this.setState({
          pauseMode: false
        })
      }, 30000)

    }

    const dataLength = this.state.messageData.length
    let newIndex = (direction === 'left') ? this.state.currentIndex - 1 : this.state.currentIndex + 1
    
    if ( newIndex > dataLength - 1 ) {
      newIndex = 0
    }
    if ( newIndex <  0 ) {
      newIndex = dataLength -1
    }

    const nextMessageObj = this.state.messageData[newIndex]
    this.setState({
      currentMessage: nextMessageObj,
      currentIndex: newIndex
    })

  }

  startTimer () {
    setInterval(() => {
      if (this.state.pauseMode === false) {
        this.nextMessage('right', 'auto')
      }
    }, 5000);
  }

  loadData () {
    // lIVE
    /*axios.get(apiURL_storage)
    .then((response) => {
      // console.log('response', response)
      let titlesRemoved = response.data.values
      titlesRemoved.shift()
      this.processItems(titlesRemoved)
    })
    .catch((err) => {
      console.log('err', err)
    })*/

      fetch(apiURL_storage)
        .then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json(); // Parse JSON from response
        })
        .then((data) => {
            let titlesRemoved = data.values;
            titlesRemoved.shift();
            titlesRemoved.reverse();
            this.processItems(titlesRemoved); // Process the items
        })
        .catch((err) => {
            console.log('err', err);
        });

  }

  processItems (items) {
    // console.log('items', items)

    if (this.state.mode === 'simple') {
      
      const randomIndex = Math.floor(Math.random()*items.length)
      const startItem = items[randomIndex]

      this.setState({
        currentMessage: startItem,
        currentIndex: randomIndex,
        messageData: items
      })

      this.startTimer()
    }

    if (this.state.mode === 'book') {
      let groupedMessages = [];

      [...Array(Math.ceil(items.length / 4)).keys()].forEach(i => {
        groupedMessages.push(items.slice(i * 4, (i+1) * 4))
      })

      groupedMessages = ['start', ...groupedMessages, 'end']

      this.setState({
        bookMessages: groupedMessages
      })
    }

  }

  nextBookButtonClick () {
    this.flipBook.pageFlip().flipNext();
  }

  prevBookButtonClick () {
    this.flipBook.pageFlip().flipPrev();
  }

  render() {

    const message = (this.state.currentMessage !== null) ? this.state.currentMessage[0].trim() : 'Loading...'
    const name = (this.state.currentMessage !== null) ? this.state.currentMessage[1].trim() : ''
    const location = (this.state.currentMessage !== null) ? this.state.currentMessage[2].trim() : ''
    const messageIndex = (this.state.currentMessage !== null) ? this.state.currentIndex : ''

    const totalMessage = <div key={messageIndex} className="nnd-message-wrap">
      <div className="nnd-message">{message}</div>
      <div className="nnd-from">- {name}, {location} -</div>
    </div>

    const bookWidth = (this.state.isDesktop === true) ? 350 : 320;
    const bookHeight = (this.state.isDesktop === true) ? 705 : 600
    const bookSize = (this.state.isDesktop === true) ? 'stretch' : 'stretch'
    const bookMinWidth = (this.state.isDesktop === true) ? 350 : 320;
    const bookMaxWidth = (this.state.isDesktop === true) ? 355 : 220;
    const bookMinHeight = (this.state.isDesktop === true) ? 705 : 600;
    const bookMaxHeight = (this.state.isDesktop === true) ? 705 : 600;
    
    const pages = (typeof this.state.bookMessages !== 'undefined') ? this.state.bookMessages.map((item, index) => {
      if (typeof this.state.bookMessages !== 'undefined') {

        if (typeof item === 'string' && item === 'start') {
          return (
            <div key={index} className="nnd-page cover">
              <div className="nnd-heading">
                <span>Share your well wishes for Charles and Camilla on their eagerly awaited visit to Australia</span>
              </div>
              {/*<div className="nnd-cover-footer">
                  {<img alt="Unplug24" src={require(`../assets/images/logo-Unplug24.svg`)} className="nnd-cover-sponsor" />}
              </div>*/}
            </div>
          )
        }
        else if (typeof item === 'string' && item === 'end') {
          return (
            <div key={index} className="nnd-page cover end">
              <div className="nnd-heading">
                <span>The End</span>
              </div>
              {/*<div className="nnd-cover-footer">
                  {<img alt="Unplug24" src={require(`../assets/images/logo-Unplug24.svg`)} className="nnd-cover-sponsor" />}
              </div>*/}
            </div>
          )
        }
        else {

          return (
            <div key={index} className={`nnd-page`} >
              <div className="nnd-page-header nnd-decor"></div>
              <div className="nnd-page-messages">
              {
                item.map((message, subIndex) => (
                  <div key={index + '-' + subIndex} className="nnd-message">
                    <div className="nnd-message-content">{message[0] ? message[0].trim() : ''}</div>
                    <div className="nnd-message-name">- {message[1] ? message[1].trim() : ''}, {message[2] ? message[2].trim() : ''} -</div>
                  </div>
                ))
              }
              </div>
              <div className="nnd-page-footer nnd-decor">
                <div className="nnd-page-number">{index}</div>  
              </div>
            </div>
          )
        }

      }
    }) : ''

    return (
      <div className="nnd-container">
        
        <div className="nnd-content-form">
          <div className="nnd-header">
            <h3><span>Your messages </span> <span>to the King </span> <span>and Queen</span></h3>
            <div className="nnd-image-tribute"></div>
          </div>
          {this.state.mode === 'book'
            ?
            this.state.submitSuccess
              ? 
              <div className="nnd-form-thanks">
                <p>{this.state.valueName}</p>
                <p>Thank you for submitting your message.</p>
                <p className="nnd-message-posted">"{this.state.valueMessage}"</p>
                <p>Click or tap below to see your message and others.</p>
              </div>
              :
              <div className="nnd-form">
                <label htmlFor="nnd-form-textarea" className="nnd-form-textarea-label">Enter your message below</label>
                <div className="inputRow nnd-input-1">
                  <input type="input" maxLength="20" disabled={false} className="nnd-form-input-name" name="nam" onChange={this.inputCount} onBlur={this.handleChangeName} placeholder="Name*" ></input>
                  <span className="nnd-count-name nnd-count">
                    <span className="nnd-countBase">{20 - this.state.countName}</span>
                  </span>
                </div>
                <div className="inputRow nnd-input-2">
                  <input type="input" maxLength="20" disabled={false} className="nnd-form-input-location" name="loc" onChange={this.inputCount} onBlur={this.handleChangeLocation} placeholder="Location*" ></input>
                  <span className="nnd-count-location nnd-count">
                    <span className="nnd-countBase">{20 - this.state.countLocation}</span>
                  </span>
                </div>
                <div className="inputRow nnd-input-3">
                  <textarea type="textarea" maxLength="150" disabled={false} className="nnd-form-textarea" name="mes" onChange={this.inputCount} onBlur={this.handleChangeMessage} placeholder="Your message*" ></textarea>
                  <span className="nnd-count-message nnd-count">
                    <span className="nnd-countBase">{150 - this.state.countMessage}</span>
                  </span>
                </div>
                <button type="button" disabled={this.state.submitDisabled} className="nnd-form-submitButton" onClick={(e) => { this.onSubmit(e) }}>Submit</button>
              </div>
            :
            ''
          }
        </div>
        
        {this.state.mode == 'book'
            ? 
            <div className="nnd-cont-main">
              <div className="nnd-book-messages">
                  <div className="nnd-nav-prev" onClick={this.prevBookButtonClick} title='PREVIOUS'></div>
                  <HTMLFlipBook 
                    width={bookWidth} 
                    height={bookHeight} 
                    size={bookSize}
                    minWidth={bookMinWidth}
                    maxWidth={bookMaxWidth}
                    minHeight={bookMinHeight}
                    maxHeight={bookMaxHeight}
                    className="nnd-book" 
                    autoSize={true}
                    maxShadowOpacity= {0.1}
                    showCover={true}
                    drawShadow={true}
                    ref={(el) => (this.flipBook = el)}>

                      { pages }
                    
                  </HTMLFlipBook>
                  <div className="nnd-nav-next" onClick={this.nextBookButtonClick} title='NEXT'></div>
              </div>
            </div>
            : 
            <div className="nnd-content-ticker">
              <div className="nnd-button-left" onClick={() => { this.nextMessage('left', 'manual') }}></div>
              {totalMessage}
              <div className="nnd-button-right" onClick={() => { this.nextMessage('right', 'manual') }}></div>
            </div>

        }
        
      </div>
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js